import $ from 'jquery';
import { commonUpload } from "./dataReport";
const newsTypeList = ['news', 'activity', 'announce'];
const mapText = ['text-1', 'text-2', 'text-3'];
const worldText = ['map', 'char', 'gongfa', 'minimap'];
const charText = ['hanli', 'nangongwan', 'yinyue', 'mojuren'];
export const initNews = () => {
  new Swiper('.j-newsPic-container', {
    autoplay: {
      delay: 4000,
    },
    loop: true,
    observer: true,
    observeParents: true,
    updateOnImagesReady: true,
    pagination: {
      el: '.j-newsPic-pagination',
      clickable: true,
    },
  });
  new Swiper('.j-news-container', {
    autoplay: false,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.j-news-type',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="news-type-btn swiper-pagination-bullet j-collect ${
            i + 1 == current ? 'swiper-pagination-bullet-active active' : ''
          } ${newsTypeList[i]} j-type-${
            newsTypeList[i]
          }" data-index="${i}" ></a>`;
        }
        html +=
          '<a href="//www.blancozone.com/frxx/list.html" target="_blank" class="more"></a>';
        return html;
      },
    },
  });
};
export const initSwiper = () => {
  const worldSwiper = new Swiper('.j-world-container', {
    autoplay: false,
    speed: 800,
    pagination: {
      el: '.j-world-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="world-btn swiper-pagination-bullet j-collect j-world-btn ${
            i + 1 == current ? 'swiper-pagination-bullet-active active' : ''
          } ${worldText[i]}" data-index="${i}" data-collect="${worldText[i]}" ></a>`;
        }
        return html;
      },
    },
    on: {
      slideChange: function () {
        commonUpload('click_button',worldText[this.realIndex]);
      }
    },
  });
  const mapSwiper = new Swiper('.j-map-container', {
    autoplay: {
      delay: 4000,
    },
    loop: true,
    speed: 1000,
    noSwiping: false,
    navigation: {
      nextEl: '.j-map-right',
      prevEl: '.j-map-left',
    },
    on: {
      slideChange: function () {
        $('.j-map-text')
          .removeClass(mapText.join(' '))
          .addClass(`text-${+this.realIndex + 1}`);
      },
    },
  });
  const charSwiper = new Swiper('.j-char-container', {
    loop: true,
    autoplay: {
      delay: 4000,
    },
    speed: 1000,
    noSwiping: false,
    pagination: {
      el: '.j-char-pag',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="swiper-pagination-bullet ${
            i + 1 == current ? 'swiper-pagination-bullet-active active' : ''
          } ${charText[i]}" data-index="${i}" ></a>`;
        }
        return html;
      },
    },
    navigation: {
      nextEl: '.j-char-right',
      prevEl: '.j-char-left',
    },
  });
  const gongfaSwiper = new Swiper('.j-gongfa-container', {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 4000,
    },
    noSwiping: false,
    navigation: {
      nextEl: '.j-gongfa-right',
      prevEl: '.j-gongfa-left',
    },
  });
  const specialSwiper = new Swiper('.j-special-container', {
    loop: true,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: '.j-special-right',
      prevEl: '.j-special-left',
    },
    pagination: {
      el: '.j-special-pagination',
      clickable: true,
    },
  });
};
